import React from "react";
import { Box } from "@twilio-paste/core";
import { useTheme } from "@twilio-paste/theme";
import styles from "../../../styles";

type Props = { greeting: string };

const ConversationEmptyState: React.FC<Props> = ({ greeting }) => {
  const theme = useTheme();

  return (
    <Box style={styles.convosWrapperBox}>
      <Box
        style={{
          display: "flex",
          height: "100%",
          flexDirection: "column",
          justifyContent: "center",
          textAlign: "center",
          fontSize: theme.fontSizes.fontSize30,
          fontWeight: theme.fontWeights.fontWeightNormal,
          lineHeight: "20px",
          color: theme.textColors.colorTextIcon,
        }}
      >
        {greeting}
      </Box>
    </Box>
  );
};

export default ConversationEmptyState;
